import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormattedMessage, defineMessages } from 'react-intl';

import Swatches from './ColorSwatches';
import Sliders from './Slider';
import {
    selectSwatchItem, hidePicker, showAllSwatches,
} from './../../actions/uiActions';
import { getPatternColors } from './../../reducers/selectors';
import ResetColors from './ResetColors';

import ColoredFlatButton from '../buttons/ColoredFlatButton';

defineMessages({
    resetColorsLinktext: {
        id: 'RESET_COLORS_LINKTITLE',
        description: 'Title of the reset colors link.',
        defaultMessage: 'Motiv auf Originalfarben zurücksetzen.',
    },
    showall: {
        id: 'SHOWALL_COLORS_LINKTITLE',
        description: 'Title of the show all colors link.',
        defaultMessage: 'Zeigt alle Farben für dieses Motiv an.',
    },
    hidall: {
        id: 'HIDEALL_COLORS_LINKTITLE',
        description: 'Title of the hide all colors link.',
        defaultMessage: 'Zeigt die Hauptfarben des Designs an und blendet die anderen Farben aus.',
    },
    recolorHelp: {
        id: 'RECOLOR_HELP_TITLE',
        description: 'Title of the help text for the recoloring help.',
        defaultMessage: 'Designe Dein Unikat ...',
    },
    resetColors: {
        id: 'RECOLOR_HELP_TEXT',
        description: 'Recoloring help text.',
        defaultMessage: '... in Deinen Wunschfarben! Klick auf ein Farbkästchen und ändere eine Einzelfarbe oder nutze die Schieberegler.',
    },
});

const resetColorText = (
    <FormattedMessage
        id='RESET_COLORS_LINKTEXT'
        description='Text of the reset colors link.'
        defaultMessage='Originalfarben'
    />
);

const Recoloring = props => {
    const handleClick = event => {
        const id = parseInt(event.target.getAttribute('data-swatch-id'), 10);
        const color = event.target.getAttribute('data-swatch-color');
        props.uiActions.selectSwatchItem(id, color);
    };

    const remainingColors = props.totalColors > props.swatchesToShow ?
        parseInt(props.totalColors, 10) - parseInt(props.swatchesToShow, 10) :
        false;

    const showAllColorsText = (
        <FormattedMessage
            id='SHOWALL_COLORS_LINKTEXT'
            description='Text of the show all colors link.'
            defaultMessage={`{remainingColors, number} {remainingColors, plural,
                      one {weitere Farbe}
                      other {weitere Farben}
                    } anzeigen `}
            values={{ remainingColors }}
        />
    );

    const hideAllColorsText = (
        <FormattedMessage
            id='HIDEALL_COLORS_LINKTEXT'
            description='Text of the hide all colors link.'
            defaultMessage={'Nur Hauptfarben anzeigen'}
            values={{ remainingColors }}
        />
    );

    const left = remainingColors > 0;

    const ShowAll = () => {
        if (remainingColors > 0) {
            if (props.showAll === false) {
                return (
                    <ColoredFlatButton
                        mt={7} mb={7} mr={8}
                        bgColor='rgba(0, 0, 0, 0.08)'
                        onClick={handleShowAll}
                        text={showAllColorsText}
                    />
                );
            }
            return (
                <ColoredFlatButton
                    mt={7} mr={8} mb={7} bgColor='rgba(0, 0, 0, 0.08)'
                    onClick={handleHideAll}
                    text={hideAllColorsText}
                />
            );
        }
        return null;
    };

    const numberOfSwatches = props.showAll ?
        props.totalColors :
        Math.min(props.swatchesToShow, props.totalColors);

    const handleShowAll = () => props.uiActions.showAllSwatches(true);

    const handleHideAll = () => props.uiActions.showAllSwatches(false);

    return (
        <div>
            <Swatches
                numberOfSwatches={numberOfSwatches}
                activeSwatch={props.activeSwatch}
                selectSwatch={handleClick} showPicker={props.showPicker}
                hidePicker={props.uiActions.hidePicker}
                showAll={props.uiActions.showAllSwatches}
            />
            <ShowAll />
            <ResetColors left={left}>{resetColorText}</ResetColors>
            <Sliders />
        </div>
    );
};

const mapDispatch = dispatch => (
    {
        uiActions: bindActionCreators({
            selectSwatchItem,
            hidePicker,
            showAllSwatches,
        }, dispatch),
    }
);

const mapState = state => {
    const { patternid } = state.location.payload;
    const colors = getPatternColors(state, patternid);
    return {
        showPicker: state.stolo.ui.recoloring.displayColorpicker,
        totalColors: colors.length,
        swatchesToShow: state.stolo.ui.recoloring.swatchesToShow,
        showAll: state.stolo.ui.recoloring.showAllSwatches,
    };
};

export default connect(mapState, mapDispatch)(Recoloring);



// WEBPACK FOOTER //
// ./src/components/recoloring/Recoloring.js